export default __webpack_public_path__ + "static/media/Vambraces of the Dark Messenger.d18ad50e.jpg";